<template>
    <div>
        <div class="p-5 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
            <span class="font-bold text-xl"><i class="fas fa-exclamation-triangle mr-1"></i> {{$t('mes_produits.devis.une_action_est_requise_de_votre_part')}}</span>
            <p>{{$t('mes_produits.devis.merci_de_valider_le_devis_ci_dessous')}}</p>

            <hr class="my-5 border-yellow-800">

            <ul class="list-decimal pl-4 mt-3">
                <li class="mb-4">
                    <b>{{$t('mes_produits.devis.consulter_le_devis')}}</b>
                    <div class="mt-2">
                        <a target="_blank" class="underline mt-2 text-blue-500 font-bold" :href="fileUrl">
                            <i class="fas fa-link"></i> {{$t('mes_produits.devis.voir_le_devis')}}
                        </a>
                    </div>
                </li>

                <li class="mb-4">
                    <b>{{$t('mes_produits.devis.que_souhaitez_vous_?')}}</b>
                    <div>
                        <div class="mt-2 mb-3">
                            <input id="accept-devis" class="outline-none focus:outline-none rind-0" type="radio" name="accept-devis" v-model="accept" value="1"> <label for="accept-devis">{{$t('mes_produits.devis.j_accepte_le_devis')}}</label>
                            <div class="my-2">
                                <input id="decline-devis" class="focus:outline-none" type="radio" name="accept-devis" v-model="accept" value="0"> <label for="decline-devis">{{$t('mes_produits.devis.je_refuse_le_devis')}}</label>
                            </div>
                        </div>
                    </div>
                </li>
                <template v-if="accept == 1">
                    <li class="mb-4">
                        <b>{{$t('mes_produits.devis.valider_le_montant_du_devis')}}</b>
                        <div class="mt-2">
                            <input
                            :placeholder="$t('mes_produits.devis.saisir_le_montant_du_devis')"
                            type="text"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                            v-model="amount"
                            @keypress="isNumber($event)"
                            >
                            <!-- <sav-input v-model="amount" @input="this.value = amount.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" :label="$t('mes_produits.devis.montant_du_devis')" type="text" />                     -->
                        </div>
                    </li>
                    <li class="mb-4">
                        <b>{{$t('mes_produits.devis.signer_le_devis')}}</b>
                        <div>
                            <sign-devis v-show="!sign" @end="endSign" :file-url="fileUrl" />
                            <div v-show="sign">
                                <div class="mt-2 text-green-600 font-light"><i class="fas fa-check mr-2"></i>{{$t('mes_produits.devis.signature_enregistree')}}</div>
                                <a class="text-blue-500 hover:underline" target="_blank" v-if="sign && sign.url" :href="sign.url"><i class="fas fa-link mr-2"></i>{{$t('mes_produits.devis.consulter_le_fichier')}}</a>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>

            <button v-if="accept != null" @click="save" class="mt-3 bg-green-500 hover:bg-green-600 text-white duration-200 px-3 py-2 text-sm font-light rounded">{{$t('mes_produits.devis.valider')}}</button>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'

import SignDevis from './components/SignDevis.vue'

export default {
    components: {SignDevis},
    props: {
        fileUrl: {required: true},
        idCase: {required: true}
    },

    data() {
        return {
            signData: null,
            amount: null,
            accept: null,
            sign: null
        }
    },

    methods: {
        endSign(sign) {
            if (sign) {
                this.sign = sign
            }
        },
        async save() {
            if (this.accept == 1 && !this.amount) {
                this.$toast.error(this.$t('mes_produits.devis.formulaire_incomplet'))
                return
            }
            let response = await apiService.post('rep_devis', {
                id_case: this.idCase,
                accept: this.accept,
                montant: this.amount,
                file_id: this.sign ? this.sign.id : null
            })
            eventHub.$emit('refresh-product')
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault()
            } else {
                return true
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/FolderActions.vue/AcceptDevisAction.vue